﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            sendCodeUrl: String,
            resendCode: String
        };
    }

    static get targets() {
        return [
            "mobileNumber",
            "sendCodeButton",
            "sendCodeMessage",
            "smsTwoFACode"
        ];
    }

    async sendCode() {
        this.sendCodeButtonTarget.disabled = true;
        this.sendCodeMessageTarget.classList.add("d-none");
        let sendCodeUrl = new URL(this.sendCodeUrlValue, location.origin);

        if (this.hasMobileNumberTarget) {
            sendCodeUrl.searchParams.set("mobileNumber", this.mobileNumberTarget.value);
        }

        const response = await fetch(sendCodeUrl, { method: "post" });
        const { message } = await response.json();
        this.sendCodeMessageTarget.textContent = message;
        this.sendCodeMessageTarget.classList.remove("d-none");
        this.smsTwoFACodeTarget.focus();
        setTimeout(
            () => {
                this.sendCodeButtonTarget.textContent = this.resendCodeValue;
                this.sendCodeButtonTarget.disabled = false;
            },
            5000
        );
    }
}